export enum ActionCode {
  SUPER_ADMIN_CODE = 'SuperAdmin',
  ADMIN_CODE = 'Admin',
  SECRETARY_USER_CODE = 'SecretaryUser',
  PHARMACY_USER_CODE = 'PharmacyUser',
  PHARMAMOVE_USER_CODE = 'PharmamoveUser',
  PUBLIGARDE_USER_CODE = 'PubliGardeUser',
}
